export const GLOBAL_VARS = {
  ENVIRONMENT: 'DEVELOPMENT',
  API: 'https://cce-api.civischile.cl/api',
};